module.exports = __webpack_public_path__ + "static/media/PlayIcon.5440d779.svg";